import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import { ChevronRight } from "lucide-react";

export default function BlogPost() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  useEffect(() => { api.get(`/blog/${slug}`).then(({data}) => setPost(data)).catch(()=>setPost(false)); }, [slug]);

  if (post === null) return <div className="container-x py-20 text-center">Loading…</div>;
  if (post === false) return <div className="container-x py-20 text-center"><div className="font-serif text-3xl">Post not found</div><Link to="/blog" className="mt-4 inline-block gold-text">Back to Journal</Link></div>;

  const schema = {
    "@context": "https://schema.org", "@type": "Article",
    headline: post.title, image: [post.cover_image],
    author: { "@type": "Organization", name: "AdiYogi Handicrafts" },
    publisher: { "@type": "Organization", name: "AdiYogi Handicrafts" },
    datePublished: post.created_at,
  };

  return (
    <article className="container-x py-16 max-w-3xl" data-testid="blog-post">
      <SEO title={post.title} description={post.excerpt} image={post.cover_image} schema={schema} />
      <div className="text-xs text-muted-foreground flex items-center gap-1 mb-6">
        <Link to="/" className="hover:gold-text">Home</Link>
        <ChevronRight className="w-3 h-3" />
        <Link to="/blog" className="hover:gold-text">Journal</Link>
        <ChevronRight className="w-3 h-3" />
        <span>{post.title}</span>
      </div>
      <div className="text-xs uppercase tracking-[0.3em] gold-text mb-3">{post.category}</div>
      <h1 className="font-serif text-4xl md:text-5xl mb-6">{post.title}</h1>
      <div className="aspect-[16/9] rounded-xl overflow-hidden border hairline mb-8"><img src={post.cover_image} alt={post.title} className="w-full h-full object-cover" /></div>
      <div className="prose prose-sm text-muted-foreground max-w-none space-y-4 whitespace-pre-line" dangerouslySetInnerHTML={{ __html: post.content.replace(/\*\*(.+?)\*\*/g, '<strong class="text-espresso">$1</strong>') }} />
      <div className="mt-12 border-t hairline pt-6 text-sm text-muted-foreground">— {post.author}</div>
    </article>
  );
}
